import { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { CardMedia, Input } from "@mui/material";

import { userState } from "../../interface/MainInterface";
import { HttpAdminApi } from "../../interface/admin-api";

import * as AuthMain from "../../auth/AuthMain";

interface propsType {
  userState: userState;
  callback: any;
  setUserInfo: any;
}

const adminApi = new HttpAdminApi();

const ChangePicture = (props: propsType) => {
  const myPhotoFileRef = useRef<HTMLInputElement>();
  const [userPictureUrl, setUserPictureUrl] = useState<string>("");
  const [hover, setHover] = useState(false);

  useEffect(() => {
    return () => {
      setUserPictureUrl("");
    };
  }, []);

  const handleFileInput = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files !== null) {
      const file = e.target.files[0];
      const mime = file.type; // 예: image/png
      const ext = mime.split('/')[1]; // png

      const newFileName = `${uuidv4()}.${ext}`;

      try {
        const photoKey = "user-photos/" + props.userState.id + "/" + newFileName;

        const param: any = {
          command: "get_cf_presigned_url",
          key: photoKey
        };
        const res = await adminApi.post(param);
        const uploadResponse = await fetch(res.response.upload_url, {
          method: "PUT",
          body: file,
          headers: {
            "Content-Type": `${file.type}`,
            acl: "public-read"
          }
        });
        console.log("upload Reponse : ", uploadResponse);
        if (!uploadResponse.ok) {
          throw new Error(`파일 업로드 실패 (HTTP ${uploadResponse.status})`);
        }

        setUserPictureUrl(res.response.object_url);
        await AuthMain.setPicture(photoKey);
        props.setUserInfo();

      } catch (e) {
        console.error("fail uploadding : ", e);
      }
    }
  };

  const update_user_picture = async () => {
    myPhotoFileRef.current?.click();
  };


  const getUrl = async (path: string) => {
    if (props.userState.picture !== "") {
      const param: any = {
        command: "get_cf_presigned_url",
        key: path,
      };
      const res = await adminApi.post(param);
      if (res.code === "200") {
        setUserPictureUrl(res.response.object_url);
      }
    }
  };

  useEffect(() => {
    if (props.userState.picture !== "") {
      getUrl(props.userState.picture);
    }
  }, [props.userState.picture]);

  return (
    <>
      <Box
        sx={{ position: "relative" }}
        onMouseOver={() => {
          setHover(true);
        }}
        onMouseOut={() => {
          setHover(false);
        }}
      >
        {userPictureUrl !== "" && (
          <CardMedia component={"img"} image={userPictureUrl} sx={{ height: "200px", borderRadius: "50%" }} />
        )}
        <Box
          sx={{
            position: "absolute",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            display: hover ? "" : "none",
          }}
        >
          <Button variant="contained" size="small" onClick={update_user_picture}>
            변경
          </Button>
        </Box>
      </Box>
      <Input
        color="primary"
        type="file"
        inputRef={myPhotoFileRef}
        onChange={handleFileInput}
        sx={{ display: "none" }}
        inputProps={{ accept: "image/*" }}
      />
    </>
  );
};

export default ChangePicture;
